export default !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);



/** WEBPACK FOOTER **
 ** ../src/utils/is-browser.js
 **/